/** StoreCompareList — ranked, clickable store rows with a mini trend line. */
import React, { useMemo } from 'react';
import { ChevronRight } from 'lucide-react';
import Sparkline from './Sparkline';

export default function StoreCompareList({ stores, sortKey, sortDir = 'desc', columns, trendKey, trendColor = '#10b981', onSelect }) {
  const ranked = useMemo(() => {
    const s = [...stores].sort((a, b) => (sortDir === 'desc' ? b[sortKey] - a[sortKey] : a[sortKey] - b[sortKey]));
    return s;
  }, [stores, sortKey, sortDir]);

  return (
    <div className="rounded-2xl qsr-card shadow-sm divide-y divide-slate-100" data-testid="store-compare-list">
      {ranked.map((s, i) => (
        <button
          key={s.id}
          onClick={() => onSelect?.(s)}
          className="w-full text-left flex items-center gap-3 p-3.5 hover:bg-slate-50 transition-colors group"
          data-testid={`compare-row-${s.id}`}
        >
          <span className="shrink-0 h-7 w-7 grid place-items-center rounded-full bg-slate-100 text-slate-700 text-xs font-bold">{i + 1}</span>
          <div className="min-w-0 flex-1">
            <div className="font-semibold text-sm text-slate-900">{s.name}</div>
            <div className="flex gap-3 mt-0.5 flex-wrap">
              {columns.map((c) => (
                <span key={c.label} className="text-[11px] text-slate-500">
                  {c.label} <span className="font-semibold text-slate-800">{c.fmt(s)}</span>
                </span>
              ))}
            </div>
          </div>
          <div className="hidden sm:block shrink-0"><Sparkline data={s[trendKey]} color={trendColor} width={90} height={30} /></div>
          <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-slate-500 shrink-0" />
        </button>
      ))}
    </div>
  );
}
